export default import.meta.ROLLDOWN_FILE_URL_WPGYjwIlzWVNM1bYhOc83w_0e0aed6e60d56f1aaf5773ca